import Button from '@components/Button';
import Prose from '@components/Prose';
import { TypographyType } from '@data/types';
import useStore from '@store/store';
import React from 'react';

interface Props extends TypographyType {
  as?: keyof JSX.IntrinsicElements;
}

const Typography: React.FC<Props> = ({
  as: Component = 'div',
  htmlContent,
  button,
}) => {
  const { setPage } = useStore();

  return (
    <Component className="w-full bg-white">
      <div className="px-4 py-16 xl:px-0 xl:py-24 w-full max-w-innerGrid h-full flex justify-center items-center flex-col mx-auto">
        <Prose htmlContent={htmlContent} style="style-3" />
        {button && (
          <Button
            {...button}
            type="button"
            onClick={() => {
              window.scrollTo(0, 0);
              setPage('the_assessment');
            }}
            className="!mt-12"
          />
        )}
      </div>
    </Component>
  );
};

export default Typography;
